'use strict';
(function () {
  angular.module('pentaApp').factory('clientCard.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/clientCards');
  }
})();
